import React from "react";
import IconChamber from "../../Icons/Module/Chamber";
import IconImager from "../../Icons/Module/Imager";
import IconLoadPort from "../../Icons/Module/Shelf";
import { EModuleType } from "../../Model/EModuleType";
import { getModuleById } from '../../redux/reducers/ModuleReducer';
import { useTypedSelector } from "../../redux/reducers/RootReducer";
import { getTemperatureSensorsCollection } from '../../redux/reducers/TemperatureReducer';
import NavSubItem from "../Sidebar/NavSubItem";
import SidebarSubmenu from "../Sidebar/SidebarSubmenu";

const TemperatureNavSubMenu = () => {
  const moduleById = useTypedSelector((state) => getModuleById(state));
  const temperatureSensorCollection = useTypedSelector((state) => getTemperatureSensorsCollection(state));

  let submenus = [];
  for (let i = 0; i < temperatureSensorCollection.allIds.length; i++) {
    const id = temperatureSensorCollection.allIds[i];
    const module = moduleById[id];
    let icon = {};
    switch (module.moduleType) {
      case EModuleType.IMAGER:
        icon = <IconImager />;
        break;
      case EModuleType.CHAMBER:
        icon = <IconChamber />;
        break;
      case EModuleType.LOADPORT:
        icon = <IconLoadPort />;
        break;
      default:
        continue;
    }

    submenus.push(
      <NavSubItem
        key={id}
        label={module.name}
        icon={icon}
        to={"/temperature/" + id}
      />
    );
  }

  return (
    <SidebarSubmenu>
      {submenus}
    </SidebarSubmenu>
  )
}

export default TemperatureNavSubMenu;